export const SET_CART_ITEMS = 'SET_CART_ITEMS';
export const ADD_CART_ITEM = 'ADD_CART_ITEM';
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM';
export const CLEAR_ITEM_FROM_CART = 'CLEAR_ITEM_FROM_CART';

export const ADD_CART_ITEM_START = 'ADD_CART_ITEM_START';
export const REMOVE_CART_ITEM_START = 'REMOVE_CART_ITEM_START';
export const CLEAR_ITEM_FROM_CART_START = 'CLEAR_ITEM_FROM_CART_START'; 

export const ADD_CART_ITEM_SUCCESS = 'ADD_CART_ITEM_SUCCESS';
export const REMOVE_CART_ITEM_SUCCESS = 'REMOVE_CART_ITEM_SUCCESS';
export const CLEAR_ITEM_FROM_CART_SUCCESS = 'CLEAR_ITEM_FROM_CART_SUCCESS';

export const ADD_CART_ITEM_FAILURE = 'ADD_CART_ITEM_FAILURE';
export const REMOVE_CART_ITEM_FAILURE = 'REMOVE_CART_ITEM_FAILURE';
export const CLEAR_ITEM_FROM_CART_FAILURE = 'CLEAR_ITEM_FROM_CART_FAILURE';